import { ServiceProps } from '../../pages/ServicesPage';
import { APP_LINK_ICONS } from './serviceContent/subContent/AppLink';

export enum IconSize {
  'medium',
  'large',
}

interface ServiceIconProps extends ServiceProps {
  size: IconSize;
  className?: string;
}

const IconSizeOptions = {
  [IconSize.medium]: 'p-5 text-xl',
  [IconSize.large]: 'p-9 text-3xl',
};

/**
 * Service Icon with dynamic color
 * @param param0
 * @returns
 */
export const ServiceIcon: React.FC<ServiceIconProps> = ({
  service,
  size,
  className = '',
}) => (
  <div
    className={
      IconSizeOptions[size] +
      ' flex justify-center items-center w-0 h-0 text-white rounded-full ' +
      className
    }
    style={{ backgroundColor: service.acf.color }}
  >
    <i
      className={
        service.acf.icon ? service.acf.icon.class : APP_LINK_ICONS.service
      }
      aria-hidden="true"
    ></i>
  </div>
);
